import React, { useEffect, useState } from 'react';
import { Badge, Card } from 'reactstrap';
import { DataTableHead, DataTableItem, DataTableRow } from '../../../../components/Component';
import * as app_consts from "../../../../utils/app_consts";
import { addThreeDots, formatToSentenceCase } from '../../../../utils/Utils';
import moment from 'moment';
import { Link } from 'react-router-dom';
import AuthTenantNoData from '../../../error/AuthTenantNoData';

const RecentTenantOrders = ({ sales, tenant_info }) => {

  const [sales_data, setSalesData] = useState(sales);

  useEffect(() => {
    setSalesData(sales);
  }, [sales]);


  return (
    <>
      <Card className="card-full">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h6 className="title">Recent Orders</h6>
            </div>
          </div>
        </div>
        <div className="nk-tb-list mt-n2">
          <DataTableHead>
            <DataTableRow>
              <span>Order No.</span>
            </DataTableRow>
            <DataTableRow size="sm">
              <span>Customer</span>
            </DataTableRow>
            <DataTableRow size="md">
              <span>Date</span>
            </DataTableRow>
            <DataTableRow>
              <span>No of Products</span>
            </DataTableRow>
            <DataTableRow>
              <span className="d-none d-sm-inline">Status</span>
            </DataTableRow>
          </DataTableHead>
          {
            sales_data ?
              sales_data?.map((item, idx) => (
                <DataTableItem key={idx}>
                  <DataTableRow>
                    <span className="tb-lead">

                      <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                        {item?.order_ref_number || "--"}
                      </Link>
                    </span>
                  </DataTableRow>
                  <DataTableRow size="sm">
                    <div className="user-card">
                      <div className="user-name">
                        <span className="tb-lead">{item?.sales_rep?.name ? addThreeDots(item?.sales_rep?.name, 30) : "--"}</span>
                      </div>
                    </div>
                  </DataTableRow>
                  <DataTableRow size="md">
                    <span className="tb-sub">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                  </DataTableRow>
                  <DataTableRow>
                    <div className="user-card">
                      <div className="user-info">
                        <span className="tb-lead">
                          {item?.no_of_products || "0"}
                        </span>
                        <span>{item?.total_value ? `${parseFloat(item?.total_value)?.toFixed(2)} ZMW` : "--"}</span>
                      </div>
                    </div>
                  </DataTableRow>
                  <DataTableRow>
                    <Badge
                      className="badge-dot badge-dot-xs"
                      color={
                        item?.status === app_consts.DISPATCHED_LOWER || item?.status === app_consts.APPROVED_LOWER ? "success" : "warning"
                      }
                    >
                      {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                    </Badge>
                  </DataTableRow>
                </DataTableItem>
              ))
              :
              <>
                <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Orders Found"} />
              </>
          }
        </div>
      </Card>
    </>
  );
};

export default RecentTenantOrders;